import React from 'react';
import {
  atlassianLogoContainer,
  atlassianHeaderContainer,
  billingCycleContainer,
  currencyText,
  estimatedCostContainer,
  estimateDateContainer,
  estimateOnlyText,
  estimateOnlyContainer,
  estimateMessageText,
  headerContainer,
  productHeaderBarStyle,
  productHeaderBoxStyle,
  pricingInformationContainer,
  pdfContainer,
  taxInformationText,
  totalPriceText,
  billingCycleText,
  dateStyle,
  verticalLine,
  footerContainer,
  estimateDateText1,
  estimateDateText2,
  pdfLayoutContainer
} from './pdf-layout.styles';
import ProductFamilyComponent from './product-family-component';
import { productFamilyNameText } from './product-family-component.styles';
import { useModuleProps } from '../../module-props';
import { PricingPeriod } from '@atlassiansox/bxp-use-pricing';
import { atlassianLogo } from '../../constants';

export interface Product {
  name: string;
  logo: React.ReactElement;
  selectedPlanName?: string;
  selectedUserCount: string;
  costPerUserType: string;
  monthlyCost: string;
  userType: string;
  userTypeTier?: string;
}
export interface ProductFamily {
  familyName: string;
  logo: React.ReactElement;
  selectedProducts?: Product[];
  apps?: Product[];
  suffix?: string;
  billingMessage?: string;
}

export interface PdfLayoutProps {
  selectedProductFamilies: ProductFamily[];
  billingCycle: PricingPeriod;
  totalCost: string;
  currency: string;
}

const PdfLayout = ({
  selectedProductFamilies,
  billingCycle,
  totalCost,
  currency
}: PdfLayoutProps) => {
  const {
    estimateDateLabel,
    estimateOnlyLabel,
    questionsLabel,
    pricingDisclaimerLabel,
    productLabel,
    planLabel,
    billingCycleLabel,
    taxNotIncludedLabel,
    estimatedMonthlyCostLabel,
    estimatedAnnulaCostLabel,
    monthlyBillingCycleLabel,
    annuallyBillingCycleLabel,
    userTypeInPdfLabel,
    costPerLabel,
    NumberAndLabel,
    tierLabelInPdf
  } = useModuleProps();

  const capitalMonthly =
    monthlyBillingCycleLabel.charAt(0).toLocaleUpperCase() +
    monthlyBillingCycleLabel.slice(1);
  const capitalAnnual =
    annuallyBillingCycleLabel.charAt(0).toLocaleUpperCase() +
    annuallyBillingCycleLabel.slice(1);
  const sortedFamilies = [...selectedProductFamilies].sort((a, b) =>
    a.familyName.localeCompare(b.familyName)
  );

  const date = new Date();
  const formattedDate = date.toLocaleString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });
  return (
    <div css={pdfLayoutContainer}>
      <div css={pdfContainer}>
        <div css={headerContainer}>
          <div css={atlassianHeaderContainer}>
            <div css={atlassianLogoContainer}>{atlassianLogo}</div>
            <div css={estimateDateContainer}>
              <div css={estimateDateText1}>
                <div css={taxInformationText}>{estimateDateLabel}</div>
                <div css={dateStyle}>{formattedDate}</div>
              </div>
              <div css={verticalLine} />
              <div css={estimateDateText2}>
                <div css={taxInformationText}>{questionsLabel}</div>
                <div css={dateStyle}>atlassian.com/contact</div>
              </div>
            </div>
          </div>
          <div css={estimateOnlyContainer}>
            <div css={estimateOnlyText}>{estimateOnlyLabel}</div>
            <div css={estimateMessageText}>{pricingDisclaimerLabel}</div>
          </div>
        </div>
        <div css={productHeaderBarStyle}>
          <div css={productHeaderBoxStyle}>
            <div className="header">
              <div className="box box1">{productLabel}</div>
              <div className="box box2">{planLabel.toLocaleUpperCase()}</div>
              <div className="box box3">
                {NumberAndLabel}
                <br />
                {userTypeInPdfLabel}
              </div>
              {billingCycle == 'ANNUAL' ? (
                <div className="box box4">
                  {userTypeInPdfLabel}
                  <br />
                  {tierLabelInPdf}
                </div>
              ) : (
                <div className="box box4">
                  {costPerLabel}
                  <br />
                  {userTypeInPdfLabel}
                </div>
              )}
              <div className="box box5">
                {billingCycle === 'MONTHLY' ? capitalMonthly : capitalAnnual}{' '}
                COST
              </div>
            </div>
            {sortedFamilies.map((family, index) => (
              <ProductFamilyComponent
                key={family.familyName + index}
                family={family}
                billingCycle={billingCycle}
              />
            ))}
          </div>
        </div>
        <div css={pricingInformationContainer}>
          <div css={billingCycleContainer}>
            <div css={productFamilyNameText}>{billingCycleLabel}:</div>
            <div css={billingCycleText}>
              {billingCycle === 'MONTHLY' ? capitalMonthly : capitalAnnual}
            </div>
          </div>
          <div css={footerContainer}>
            <div css={estimatedCostContainer}>
              <div css={productFamilyNameText}>
                {billingCycle === 'MONTHLY'
                  ? estimatedMonthlyCostLabel
                  : estimatedAnnulaCostLabel}
              </div>
              <div css={taxInformationText}>{taxNotIncludedLabel}</div>
            </div>
            <div css={totalPriceText}>{totalCost}</div>
            <div css={currencyText}>{currency}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PdfLayout;
